import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Droplet = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M9.692.197c.148-.263.582-.263.728 0 .24.43 5.892 10.591 5.892 13.547A6.263 6.263 0 0 1 10.056 20 6.263 6.263 0 0 1 3.8 13.744C3.8 10.788 9.45.628 9.692.197M7.513 13.416a.833.833 0 0 0-1.658-.165c-.08.79.042 1.976.719 2.973.718 1.058 1.976 1.776 3.882 1.685a.833.833 0 1 0-.08-1.665c-1.393.067-2.067-.43-2.423-.955-.397-.586-.492-1.35-.44-1.873" }) }));
});
Droplet.displayName = 'Droplet';
Droplet.__iconComponentType = 'standard';
export default Droplet;
//# sourceMappingURL=Droplet.js.map